import { render, staticRenderFns } from "./PostCardContent.vue?vue&type=template&id=724f56d9"
import script from "./PostCardContent.vue?vue&type=script&lang=js"
export * from "./PostCardContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports